import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useMobileMenu } from "../hooks/useMobileMenu";
import { DEPORTES_LISTA } from "../data/deportes";

export default function Header() {
    const { isOpen, toggleMenu, closeMenu } = useMobileMenu();
    const { pathname } = useLocation();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(closeMenu, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";
    }, [isOpen]);

    return (
        <header className={`site-header ${scrolled && !isOpen ? "solid" : ""}`}>
            <Link to="/" className="wordmark" aria-label="Lorely, inicio">
                <span className="wordmark-name">LORELY<span>.</span></span>
                <span className="wordmark-tag">Fotografía deportiva</span>
            </Link>

            <nav id="site-nav" className={`site-nav ${isOpen ? "open" : ""}`}>
                {DEPORTES_LISTA.map((d) => (
                    <NavLink key={d.id} to={`/deporte/${d.id}`}>{d.corto}</NavLink>
                ))}
                <NavLink to="/bio">Sobre mí</NavLink>
                <Link to="/contacto" className="btn btn-volt">Cotizar</Link>
            </nav>

            <button
                className="menu-toggle"
                onClick={toggleMenu}
                aria-expanded={isOpen}
                aria-controls="site-nav"
                aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
            >
                <span /><span />
            </button>
        </header>
    );
}
